import styled from "styled-components";

const Main = styled.main`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
`;

export default Main;
